import cx from 'classnames';
import { forwardRef } from 'react';

import { ICardProps } from './types';

const Card = forwardRef<HTMLDivElement, ICardProps>(({ className, children }: ICardProps, ref) => (
  <div ref={ref} className={cx('flex flex-col p-6 bg-background-base-primary rounded-xl', className)}>
    {children}
  </div>
));
Card.displayName = 'Card';

export { Card };
